import { Brain, Info } from 'lucide-react';

const SUPPORTED_TOOLTIP = 'This diagnosis is included in the configured diagnosis set used to support Psychiatric PHP medical-necessity review. Diagnosis alone does not establish Medicare PHP eligibility or claim billability.';
const NONSUPPORTED_TOOLTIP = "This diagnosis remains part of the patient's medical record but is not classified as a Psychiatric PHP-supported diagnosis by the currently configured rule set.";

/** Visual classification badge for a diagnosis row: green for Psychiatric/PHP-supported,
 *  neutral blue-gray for non-psychiatric (never red — red is reserved for warnings/errors). */
export default function DiagnosisClassBadge({ diagnosis, compact = false }) {
  if (!diagnosis) return null;
  const supported = diagnosis.psychiatric_php_supported === true;
  const cls = compact ? ' dx-class-compact' : '';
  if (supported) {
    return (
      <span className={`dx-class dx-class-psych${cls}`} title={SUPPORTED_TOOLTIP}>
        <Brain size={12} aria-hidden />
        <span>Psychiatric / PHP Supported</span>
      </span>
    );
  }
  return (
    <span className={`dx-class dx-class-secondary${cls}`} title={NONSUPPORTED_TOOLTIP}>
      <Info size={12} aria-hidden />
      <span>Non-psychiatric</span>
    </span>
  );
}
